import React, {useState,useEffect, useRef}  from 'react';
import { format } from "date-fns";
import calendar from '../../../assets/Images/uit_calender.png'
import "./EmailDashboard.scss"
import { IoIosAdd } from "react-icons/io";
import { FaAngleRight } from "react-icons/fa6";
import { FaAngleLeft } from "react-icons/fa6";
import chart from '../../../assets/Images/BarLineChart.png';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { IoClose } from "react-icons/io5";
import Swal from 'sweetalert2';
import { MdOutlineArrowBackIos } from "react-icons/md";
import axios from 'axios';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend, ResponsiveContainer } from "recharts";
 import 'react-quill/dist/quill.snow.css'
 import ReactQuill from 'react-quill';
 import { FaMailBulk } from "react-icons/fa";


function SendEmailForm() {

    const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

      // When creating or setting campaign name


       const location = useLocation();
       const [emails,setEmails] = useState([]);
       const [campaigns, setCampaigns] = useState([]);
       const [activeTab, setActiveTab] = useState("mails");
       const [containers, setContainers] = useState([]);
       const [chartData, setChartData] = useState()
         const [templateName, setTemplateName] = useState('');
       const [showDropdown, setShowDropdown] = useState(false);
       const dropdownRef = useRef(null);
       const quillRef = useRef(null);
       const [templateMessage, setTemplateMessage] = useState("");
      const fromContacts = location.state?.fromContacts;
      const [fromDate, setFromDate] = useState("");
      const [toDate, setToDate] = useState("");
      const [isOpen, setIsOpen] = useState(false);
      const [index, setIndex] = useState(0);
      const navigate = useNavigate("")
      const wrapperRef = useRef(null);
      const [showPopup, setShowPopup] = useState(false);
      const popupRef = useRef(null);
         const [isOpentemplate, setIsOpenTemplate] = useState(false);
         const [templates, setTemplates] = useState([]);
          const incomingTemplate = location.state?.selectedTemplate || null;
     
        const openModal = () => setIsOpenTemplate(true);
  const closeModal = () => setIsOpenTemplate(false);
      const [campaignName, setCampaignName] = useState("");
      const [stats, setStats] = useState({
        total: 0,
        opened: 0,
        clicked: 0,
        openRate: '0%',
        clickRate: '0%',
        statusCounts: {},
        emails: [],
      });

const { id } = useParams();
 const [loading, setLoading] = useState(true);
  
  const togglePicker = () => setIsOpen(!isOpen);

   const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setShowDropdown(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
 
const fetchStatus = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(`${baseURL}/api/create-campaign`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const campaigns = res.data || [];

    const sentCampaigns = campaigns.filter(c => c.status === "sent");

    if (sentCampaigns.length === 0) {
      // Default values (ALL 0)
      const containersData = [
        { title: "Campaign Sent", percentage: "", countLabel: "0 Sent" },
        { title: "Open Rate", percentage: "0%", countLabel: "0 Opened" },
        { title: "Click Rate", percentage: "0%", countLabel: "0 Clicked" },
        { title: "Unsubscribe Rate", percentage: "0%", countLabel: "0 Unsubscribed" },
        { title: "Bounce Rate", percentage: "0%", countLabel: "0 Bounced" },
        { title: "Delivery Rate", percentage: "0%", countLabel: "0 Delivered" },
      ];

      const defaultChart = [
        { date: "", openRate: 0, clickRate: 0, deliveryRate: 0 }
      ];

      setContainers(containersData);
      setChartData(defaultChart);
      return;
    }

    // ✅ Existing logic for when there is data
    const latestCampaign = sentCampaigns.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    )[0];

    const {
      openRate,
      clickRate,
      bounceRate,
      unsubscribeRate,
      totalRecipients,
      openedCount,
      clickedCount,
      bouncedCount,
      unsubscribedCount,
      recipientList,
    } = latestCampaign;

    const deliveredCount = totalRecipients - bouncedCount;
    const deliveredRate = Math.round((deliveredCount / totalRecipients) * 100);

    const containersData = [
      { title: "Campaign Sent", percentage: "", countLabel: `${totalRecipients} Sent` },
      { title: "Open Rate", percentage: openRate || "0%", countLabel: `${openedCount || 0} Opened` },
      { title: "Click Rate", percentage: clickRate || "0%", countLabel: `${clickedCount || 0} Clicked` },
      { title: "Unsubscribe Rate", percentage: unsubscribeRate || "0%", countLabel: `${unsubscribedCount || 0} Unsubscribed` },
      { title: "Bounce Rate", percentage: bounceRate || "0%", countLabel: `${bouncedCount || 0} Bounced` },
      { title: "Delivery Rate", percentage: deliveredRate ? `${deliveredRate}%` : "0%", countLabel: `${deliveredCount || 0} Delivered` },
    ];

    const chartData = recipientList?.length > 0
      ? recipientList.map(r => ({
          date: new Date(r.timestamp).toISOString().split("T")[0],
          openRate: parseFloat(openRate.replace("%", "")) || 0,
          clickRate: parseFloat(clickRate.replace("%", "")) || 0,
          deliveryRate: deliveredRate || 0,
        }))
      : [{ date: "", openRate: 0, clickRate: 0, deliveryRate: 0 }];

    const uniqueChartData = Object.values(
      chartData.reduce((acc, curr) => {
        acc[curr.date] = curr;
        return acc;
      }, {})
    ).sort((a, b) => new Date(a.date) - new Date(b.date)).slice(-10);

    setContainers(containersData);
    setChartData(uniqueChartData);
  } catch (err) {
    console.error("Error fetching campaign status", err);
    
    setContainers([
      { title: "Campaign Sent", percentage: "", countLabel: "0 Sent" },
      { title: "Open Rate", percentage: "0%", countLabel: "0 Opened" },
      { title: "Click Rate", percentage: "0%", countLabel: "0 Clicked" },
      { title: "Unsubscribe Rate", percentage: "0%", countLabel: "0 Unsubscribed" },
      { title: "Bounce Rate", percentage: "0%", countLabel: "0 Bounced" },
      { title: "Delivery Rate", percentage: "0%", countLabel: "0 Delivered" },
    ]);
    setChartData([{ date: "", openRate: 0, clickRate: 0, deliveryRate: 0 }]);
  }
};




useEffect(() => {
  fetchStatus();
}, []);

useEffect(() => {
  const fetchUserEmails = async () => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');

    try {
      const response = await fetch(`${baseURL}/api/individual-emails/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (response.ok) {
        if (data.emails && data.emails.length > 0) {
          const sortedEmails = data.emails.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setEmails(sortedEmails);
        } else {
          setEmails([]); // No emails — just keep empty
        }
      } else {
        console.error(data.message || "Failed to fetch emails");
      }
    } catch (err) {
      console.error("Error fetching emails", err);
    }
  };

  fetchUserEmails();
}, []);

useEffect(() => {
  const fetchCampaigns = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${baseURL}/api/create-campaign`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      if (response.ok) {
        if (result && result.length > 0) {
          const sortedCampaigns = result
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .slice(0, 7);
          setCampaigns(sortedCampaigns);
        } else {
          setCampaigns([]); // No campaigns — default empty state
        }
      } else {
        console.error(result.message || "Failed to fetch campaigns");
        setCampaigns([]); // Ensure no crash
      }
    } catch (err) {
      console.error("Error fetching campaigns", err);
      setCampaigns([]);
    }
  };

  fetchCampaigns();
}, []);
   const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ['link', 'image'],
      ['clean'],
    ],
  }
 const handleInsertText = (text) => {
  if (!quillRef.current) return;

  const quill = quillRef.current.getEditor(); // get Quill editor instance
  const range = quill.getSelection();

  if (range) {
    quill.insertText(range.index, text); // insert variable at cursor
    quill.setSelection(range.index + text.length); // move cursor after inserted text
  } else {
    // if no selection, just append at the end
    quill.insertText(quill.getLength() - 1, text);
  }
};

// Example for emails:
const filteredEmails = emails.filter((mail) => {
  const mailDate = new Date(mail.createdAt);

  if (fromDate && toDate) {
    return (
      mailDate >= new Date(fromDate) &&
      mailDate <= new Date(toDate + "T23:59:59") 
    );
  }
  return true; 
});

const filteredCampaigns = campaigns.filter((campaign) => {
  const campaignDate = new Date(campaign.createdAt);

  if (fromDate && toDate) {
    return (
      campaignDate >= new Date(fromDate) &&
      campaignDate <= new Date(toDate + "T23:59:59")
    );
  }
  return true; 
});

  const fetchTemplates = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${baseURL}/api/get-templates`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
     let allTemplates = response.data || [];

       if (incomingTemplate) {
      allTemplates = allTemplates.filter(t => t.name !== incomingTemplate.name);
    }
    setTemplates(response.data || []);
  } catch (error) {
   Swal.fire({
             icon: 'error',
             title: 'Error',
             text: 'Something went wrong!',
             confirmButtonColor: 'red',
           });
  }
};

 const handleSaveTemplate = async () => {
  
      const token = localStorage.getItem('token');
  
      if (!templateMessage.trim()) return  Swal.fire({
      icon: 'warning',
      title: 'Empty Message',
      text: 'Message cannot be empty.',
       confirmButtonColor:"#FCB124",
      willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
    });;
  
      const response = await fetch(`${baseURL}/api/save-template`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          name: templateName || null,
          message: templateMessage,
        }),
      });
  
      const data = await response.json();
      if (response.ok) {
        Swal.fire({
           icon: "success",
          text: `Template "${data.template.name}" saved successfully`,
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
          willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
        })
        setIsOpenTemplate(false);
        setTemplateMessage('');
        setTemplateName('');
        fetchTemplates();
      } else {
        Swal.fire({
          icon:"warning",
          text:`${data.message}`,
          confirmButtonColor:"#FCB124",
          confirmButtonText:"OK",
          willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
        })
      }
    };

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    }

    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup]);

  const formatDate = (date) =>
    date ? format(new Date(date), "dd MMM yyyy") : "";

  
  const handleNext = () => {
    if (index + 4 < containers.length) {
      setIndex(index + 1);
    }
  };

  const handlePrev = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  }

  const handleSave = () => {
  if (!campaignName.trim()) {
    Swal.fire({
      icon: "warning",
      text: "Please Enter a Campaign Name",
      confirmButtonColor:"#FCB124",
      willOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '3000';
      }
    });
    return;
  }

  localStorage.setItem("campaignName", campaignName);
  navigate("/campaign", { state: { campaignName } });
};

   
 const handleBackToContacts = () => {
  navigate("/my-contacts", { state: { openProfileId: id } }); 
};

  return (
  <div className="email-form-container">
  <div className='email-campaign'>
    <div className='email-analytics'>
      {fromContacts && (
        <button
          className="company-back"
          onClick={handleBackToContacts}
        >
          <MdOutlineArrowBackIos />
          <h4>Back</h4>
        </button>
      )} Email Analytics</div>
    <div className='date-template' ref={dropdownRef} style={{ position: "relative" }}>
      <div className='date-pick' ref={wrapperRef}  style={{ position: "relative", display: "inline-block" }}>
        <button className='pick-date' onClick={togglePicker}>
          <span role="img" aria-label="calendar">
            <img src={calendar} alt="calendar" width="20px" style={{ paddingTop: "2px" }} />
          </span>
          {fromDate && toDate ? `${formatDate(fromDate)} - ${formatDate(toDate)}` : "Pick a Date"}
        </button>
     {isOpen && (
    <div
      className="date-popup"
      style={{
        position: "absolute",
        top: "120%", 
        left: 0,
        marginRight:"50px",
        marginTop: "8px",
        background: "white",
        border: "1px solid #ccc",
        padding: "16px",
        borderRadius: "4px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        zIndex: 9999,
      }}
      
    >
      <label
        htmlFor="fromDate"
        style={{ display: "block", marginBottom: "4px", fontWeight: "600" }}
      >
        Pick From Date (GMT):
      </label>
      <input
        id="fromDate"
        type="date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
        max={toDate || ""}
        style={{
          padding: "8px",
          fontSize: "14px",
          width: "200px",
          marginBottom: "12px",
          boxSizing: "border-box",
        }}
      />
      <label
        htmlFor="toDate"
        style={{ display: "block", marginBottom: "4px", fontWeight: "600" }}
      >
        Pick To Date (GMT):
      </label>
      <input
        id="toDate"
        type="date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
        min={fromDate || ""}
        style={{
          padding: "8px",
          fontSize: "14px",
          width: "200px",
          boxSizing: "border-box",
        }}
      />
    </div>
  )}

      </div>
      <button className='temp-btn'  onClick={toggleDropdown}>
          View Template
      </button>
       {showDropdown && (
        <div
          className="dropdown-menu"
          style={{
            position: "absolute",
            top: "40px", 
            left:"120px",
            right: "0",
            background: "#fff",
            width:"200px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            zIndex: "1000",
          }}
        >
          <div style={{ margin: 0, padding: "10px 0" }}>
            <div style={{ padding: "8px 20px", cursor: "pointer", fontSize:"15px", fontWeight:"500" }} onClick={() => {openModal();setShowDropdown(false);  }}>New Template</div>
            <div style={{ padding: "8px 20px", cursor: "pointer" , fontSize:"15px", fontWeight:"500"}} onClick={() => navigate("/template", { state: { from: "dashboard" } })}>Template Library</div>
            <div style={{ padding: "8px 20px", cursor: "pointer", fontSize:"15px", fontWeight:"500" }} onClick={() => navigate("/mytemplate", { state: { from: "dashboard" } })}>My Templates</div>
          </div>
        </div>
      )}
       {isOpentemplate && (
              <div className="modal-overlay">
                <div className="modal-content" ref={popupRef}>
                  <div className='campaign' style={{textAlign:"left", fontSize:"15px",fontWeight:'500'}}><FaMailBulk/>
                   &nbsp;Create Template</div>
      
                    <div  style={{marginTop:"20px", textAlign:"left", fontSize:"15px", marginLeft:"10px", }}>
                      Template Name </div>
                  <input
                    type="text"
                    placeholder="Enter your template name"
                    style={{width:"560px", border:"0.2px solid rgba(0, 0, 0, 0.25)",
                       height:"22px", borderRadius:"5px", marginTop:"20px", padding:"10px"}}
                        value={templateName}
                    onChange={(e) => setTemplateName(e.target.value)}
                  />
                   <select className="send-email-select" style={{width:"300px", height:"40px", borderRadius:"5px", marginTop:"20px", padding:"10px", marginLeft:"10px"}}
                    onChange={(e) => handleInsertText(e.target.value)}
                      defaultValue="">
                   <option value="" disabled>Instant Variables</option>
                  <option value="{{name}}">Name</option>
                      <option value="{{date}}">Date</option>
                      <option value="{{eSendEmailForm}}">SendEmailForm</option>
                               
                 </select>
                   {/* <textarea
                 theme="snow"
              style={{width:"580px", height:"110px", marginTop:"10px", borderRadius:"5px", marginTop:"20px", marginLeft:"10px", border:"1px solid #ccc",}}
                 placeholder="Enter your template message..."
              
                name="message"
                 value={templateMessage}
                    onChange={(e) => setTemplateMessage(e.target.value)}
                    ref={textareaRef}
                
              /> */}
                 <ReactQuill
        ref={quillRef}
        theme="snow"
        style={{
          width: "580px",
          height: "110px",
          borderRadius: "10px",
          marginTop: "20px",
          marginLeft: "10px"
        }}
        placeholder="Your Message"
        className="sent-date-quill"
        name="message"
        value={templateMessage}
        onChange={(content) => setTemplateMessage(content)} 
        modules={modules}
      />
      
      
                  <div className="modal-actions">
                    <button onClick={closeModal} className="cancel-temp-btn">
                      Cancel
                    </button>
                    <button className="save-temp-btn" onClick={handleSaveTemplate}>Save</button>
                  </div>
                </div>
              </div>
            )}
      <button className='camp-btn' onClick={() => setShowPopup(true)}>
        <IoIosAdd style={{ fontSize: "32px", fontWeight: "600" }} /> Create Campaign
      </button>
    </div>
  </div>
{showPopup && (
  <div className="campaign-overlay" >
    <div className="campaign-name-popup"  ref={popupRef}>
      <div className="campaign-popup-header">
        <div style={{fontSize:"19px", fontWeight:"500"}}>Create Campaign</div>
        <button className="campaign-close-btn" onClick={() => setShowPopup(false)}><IoClose /></button>
      </div>
      <div className="campaign-popup-body">
        <label style={{fontSize:"16px"}}>
          Campaign Name<span style={{ color: "red" }}> *</span>
        </label>
        <input type="text" placeholder="Enter campaign name"   value={campaignName}
         
             onChange={(e) => setCampaignName(e.target.value)}
          />
      </div>
      <div className="campaign-popup-footer">
        <button className="campaign-save-btn" onClick={handleSave}>Save and Proceed</button>
      </div>
    </div>
  </div>
)}

  <div className="email-analytics-wrapper">
    <button
      className="arrow-btn arrow-btn-left"
      onClick={handlePrev}
      disabled={index === 0}
    >
      <FaAngleLeft />
    </button>

    <div className="email-containers" >
        {containers.slice(index, index + 4).map((container, i) => (
    <div className="containers" key={i}>
      <div className="container-data">{container.title}</div>
      <div className="container-data2">{container.percentage}</div>
      {container.countLabel && (
        <div className="container-data">{container.countLabel}</div>
      )}
    </div>
  ))}
    </div>

    <button
      className="arrow-btn arrow-btn-right"
      onClick={handleNext}
      disabled={index + 4 >= containers.length}
    >
      <FaAngleRight />
    </button>
  </div>
  <div className='email-performance'>
     <div className='performance-chart'>
      <div className='performance'>
        Performance Overtime
      </div>
     {chartData && chartData.length > 0 && (
  <ResponsiveContainer height={300} width={400}>
    <LineChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" />
      <YAxis domain={[0, 100]} />
      <Tooltip />
      <Legend />
      <Line type="monotone" dataKey="openRate" stroke="#8884d8" strokeWidth={2} dot={{ r: 5 }} name="Open rate" />
      <Line type="monotone" dataKey="clickRate" stroke="#00C49F" strokeWidth={2} dot={{ r: 5 }} name="Click rate" />
      <Line type="monotone" dataKey="deliveryRate" stroke="#FFBB28" strokeWidth={2} dot={{ r: 5 }} name="Delivery rate" />
    </LineChart>
  </ResponsiveContainer>
)}
  </div>
 <div className="campaigns-list">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: "30px" }}>
          <div
            className={`all-mail ${activeTab === "mails" ? "active" : ""}`}
            onClick={() => setActiveTab("mails")}
            style={{ cursor: "pointer" }}
          >
            All Mails
          </div>
          <div
            className={`all-campaigns ${activeTab === "campaigns" ? "active" : ""}`}
            onClick={() => setActiveTab("campaigns")}
            style={{ cursor: "pointer" }}
          >
            All Campaigns
          </div>
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/allmail", { state: { selectedTab: activeTab === "mails" ? "All Mails" : "All Campaign" } })}
        >
          View All{" "}
          <FaAngleRight
            style={{
              fontSize: "10px",
              background: "#DADADA",
              borderRadius: "50%",
            }}
          />
        </div>
      </div>

      <div className="table-container">
        <table className="campaigns-table">
          <thead>
           {activeTab === "mails" && (
              <tr>
                <th>Email Id</th>
                <th>Subject</th>
                <th>Status</th>
                <th>Sent Time/Date</th>
              </tr>
            )}
 {activeTab === "campaigns" && (
              <tr>
                 <th>Campaign Name</th>
                 <th>Total Emails</th>
                  <th>Status</th>
                 <th>Sent Time/Date</th>
              </tr>
            )}
          </thead>
       <tbody>
  {activeTab === "mails" && (
    filteredEmails.length > 0 ? (
      [...filteredEmails]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0,5)
        .map((mail, index) => {
          const date = new Date(mail.createdAt);
          const options = { month: "short", day: "numeric" };
          const formattedDate = date.toLocaleDateString("en-US", options);
          const formattedTime = date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          });

          return (
            <tr key={index}>
              <td>{mail.recipientEmail}</td>
              <td>{mail.subject || "No subject"}</td>
              <td>{mail.status}</td>
              <td>{`${formattedDate} ${formattedTime}`}</td>
            </tr>
          );
        })
    ) : (
      <tr>
        <td colSpan="4" style={{ textAlign: "center" }}>No Mails</td>
      </tr>
    )
  )}

 {activeTab === "campaigns" && (
  filteredCampaigns.length > 0 ? (
    [...filteredCampaigns]
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 5)
      .map((campaign, index) => (
        <tr key={index}>
          <td>{campaign.campaignName}</td>
          <td>{campaign.totalRecipients || 0}</td>
          <td>{campaign.status}</td>
          <td>
            {campaign.createdAt
              ? new Date(campaign.createdAt).toLocaleString("en-US", {
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })
              : "N/A"}
          </td>
        </tr>
      ))
  ) : (
    <tr>
      <td colSpan="4" style={{ textAlign: "center" }}>No campaigns</td>
    </tr>
  )
)}

</tbody>


        </table>
      </div>
    </div>

  </div>
</div>

  )
}

export default SendEmailForm